import { inject, InjectionKey } from 'vue';
import { ManualBalanceApiService } from './manualBalanceApiService';

export const MANUALBALANCE_API_KEY: InjectionKey<ManualBalanceApiService> = Symbol('ManualBalanceApiService');

export function useManualBalanceApiService(): ManualBalanceApiService {
	const service = inject<ManualBalanceApiService>(MANUALBALANCE_API_KEY);
	if (!service) throw new Error('ManualBalanceApiService not provided');
	return service;
}
